import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedOvw202603: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_ovw_202603",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-03-01",
  endDate: "2026-03-31",
  impressions: 44471,
  clicks: 857,
  adsSpendDollars: 2470,
  budgetDollars: 2900,
  salesDollars: 8611,
  bestEstimateRoas: 3.49,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.85,
  newCustomersAcquired: 15,
  reorderConversions: 4,
  dataAvailableAtDate: "2026-04-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
